import { FaStar } from "react-icons/fa6";
import { LuWallet } from "react-icons/lu";
import { map } from "lodash";
import PackageCountdown from "@/Component/Common/PackageCountdown";
import { getReviewCount, getSeatsLeftLabel } from "@/utils/packageCardMeta";
import { formatIndianPrice } from "@/utils/formatIndianPrice";
import { isIndianUser } from "@/utils/getCountryCode";
import { getCurrencySymbol } from "@/utils/getCurrencySymbol";
import { INCLUSION_ICONS } from "@/utils/Inclusions";
import styles from "./SmartSearchPackageCard.module.css";

const handleRouteRegion = (path) => (isIndianUser() ? `/in${path}` : path);

export default function SmartSearchPackageCard({ item, onViewDeal }) {
  const nights = item.nights;
  const inclusions = {
    flight: Boolean(item.isFlightIncluded),
    meal: Boolean(item.isMealsIncluded),
    transfer: Boolean(item.isTransferIncluded),
    hotel: Boolean(item.isHotelIncluded),
    visa: Boolean(item.isVisaIncluded),
    activity: Boolean(item.isActivityIncluded),
  };
  const activeInclusions = INCLUSION_ICONS.filter(({ id }) => inclusions?.[id]);
  const href = handleRouteRegion(`/holiday/${item.slug}`);
  const seatsLeft = getSeatsLeftLabel(item);
  const reviewCount = getReviewCount(item);
  const rating = item?.reviews?.averageRating ?? item.rating;

  return (
    <article className={styles.card}>
      <a href={href} className={styles.imageLink} aria-label={item.packageName || item.title}>
        <div className={styles.imageWrap}>
          <img src={item.imagePath} alt={item.title} className={styles.cardImage} />

          {item.tagOnThumbnail && (
            <span className={styles.badgeBest}>
              <FaStar style={{ marginTop: "-2px" }} />
              {item.tagOnThumbnail}
            </span>
          )}
          {seatsLeft ? <span className={styles.badgeSeats}>{seatsLeft}</span> : null}
          {item.badge?.type === "emi" && (
            <span className={styles.badgeEmi}>
              <LuWallet style={{ marginTop: "-2px" }} />
              {item.badge.label} &nbsp;·&nbsp; {item.badge.month}
            </span>
          )}

          {nights ? (
            <span className={styles.duration}>
              {nights}N / {nights + 1}D
            </span>
          ) : null}
          {rating ? (
            <span className={styles.rating}>
              <strong style={{ color: "#0B192C", marginTop: "2px" }}>{rating}</strong>
              <FaStar color="#FFB835" />
              {reviewCount != null ? ` (${reviewCount})` : null}
            </span>
          ) : null}
        </div>
      </a>

      <div className={styles.body}>
        <h3 className={styles.cardTitle}>
          <a href={href} className={styles.titleLink}>{item.packageName}</a>
        </h3>
        <p className={styles.cardSubtitle}>
          {map(item.cities, (city) => `${city.nights}N ${city.city.cityName}`).join(" | ")}
        </p>
        <div className={styles.cardIncludes}>
          <div className={styles.inclusion}>
            {map(activeInclusions, (inclusion) => (
              <span key={inclusion.id} className={styles.includeIcon}>
                {(inclusion.id === "flight" && item.flightSubText) ?
                  <span className={styles.flightSubTextTip}>{item.flightSubText}</span>
                  :
                  null
                }
                {inclusion.icon}
              </span>
            ))}
          </div>
          <PackageCountdown item={item} className={styles.cardTimer} />
        </div>
        <div className={styles.footer}>
          <span className={styles.discountTag}>{item.discountTag}</span>
          <div className={styles.footerContent}>
            <div className={styles.priceBlock}>
              <p className={styles.starting}>
                Starting From
                <span className={styles.oldPrice}>
                  {getCurrencySymbol("sub", 10)}
                  {formatIndianPrice(item.displayCutPrice)}
                </span>
              </p>
              <p className={styles.price}>
                {getCurrencySymbol("main", 16)}
                {formatIndianPrice(item.price)}
                <span className={styles.perPerson}>/Person</span>
              </p>
            </div>
            {/* {onViewDeal ? (
              <button
                type="button"
                className={styles.viewDealsBtn}
                onClick={() => onViewDeal(item)}
              >
                Make It Mine
              </button>
            ) : ( */}
            <a href={href} className={styles.viewDealsBtn}>
              Make it mine
            </a>
            {/* )} */}
          </div>
        </div>
      </div>
    </article>
  );
}
